var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _g, _path15, _path16, _rect, _rect2, _rect3, _rect4, _path17, _path18, _path19, _path20, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _path21, _path22, _path23, _rect12, _rect13, _rect14, _rect15, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOpenNewTabImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 301,
    height: 139,
    viewBox: "0 0 301 139",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M69.9345 30.7837V112.483C69.9345 113.297 69.774 114.103 69.4621 114.855C69.1503 115.607 68.6934 116.29 68.1177 116.863C67.5419 117.437 66.8587 117.891 66.1075 118.199C65.3563 118.506 64.5518 118.661 63.7406 118.656H53.1241C55.1922 118.656 57.1757 117.831 58.6382 116.363C60.1006 114.895 60.9221 112.904 60.9221 110.828C60.9221 108.752 60.1006 106.761 58.6382 105.293C57.1757 103.825 55.1922 103 53.1241 103H16.9523C14.8842 103 12.9007 102.175 11.4383 100.707C9.97587 99.2393 9.1543 97.2484 9.1543 95.1724C9.1543 93.0963 9.97587 91.1053 11.4383 89.6373C12.9007 88.1693 14.8842 87.3446 16.9523 87.3446H36.7147C38.783 87.3446 40.7665 86.5199 42.2288 85.0519C43.6912 83.5839 44.5129 81.593 44.5129 79.517C44.5129 77.4408 43.6912 75.4499 42.2288 73.9819C40.7665 72.5138 38.783 71.6892 36.7147 71.6892H16.9523C14.8842 71.6892 12.9007 70.8645 11.4383 69.3965C9.97587 67.9284 9.1543 65.9375 9.1543 63.8614C9.1543 61.7854 9.97587 59.7944 11.4383 58.3264C12.9007 56.8584 14.8842 56.0337 16.9523 56.0337H42.4073C44.4756 56.0337 46.4591 55.209 47.9214 53.741C49.3838 52.273 50.2055 50.2821 50.2055 48.2059C50.2055 46.1299 49.3838 44.139 47.9214 42.671C46.4591 41.2029 44.4756 40.3783 42.4073 40.3783H27.6803C25.612 40.3783 23.6286 39.5536 22.1662 38.0856C20.7037 36.6175 19.8822 34.6266 19.8822 32.5505C19.8822 30.4745 20.7037 28.4836 22.1662 27.0155C23.6286 25.5475 25.612 24.7228 27.6803 24.7228H63.7406C65.3602 24.7108 66.9189 25.3404 68.0787 26.4753C69.2383 27.6101 69.9053 29.1583 69.9345 30.7837Z",
    fill: "url(#paint0_linear_22249_6021)",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M227.963 33.9641V114.335C227.963 115.134 228.12 115.924 228.426 116.661C228.731 117.398 229.179 118.068 229.744 118.631C230.307 119.195 230.977 119.642 231.715 119.946C232.452 120.251 233.243 120.407 234.039 120.405H244.546C242.505 120.405 240.549 119.594 239.106 118.151C237.663 116.707 236.854 114.749 236.854 112.708C236.854 110.666 237.663 108.709 239.106 107.265C240.549 105.822 242.505 105.011 244.546 105.011H280.198C282.239 105.011 284.195 104.2 285.638 102.756C287.081 101.313 287.89 99.3548 287.89 97.3133C287.89 95.2718 287.081 93.314 285.638 91.8704C284.195 90.4268 282.239 89.6159 280.198 89.6159H260.735C258.694 89.6159 256.738 88.805 255.295 87.3614C253.852 85.9178 253.042 83.9601 253.042 81.9187C253.042 79.8771 253.852 77.9193 255.295 76.4757C256.738 75.0322 258.694 74.2212 260.735 74.2212H280.198C282.239 74.2212 284.195 73.4103 285.638 71.9667C287.081 70.5231 287.89 68.5654 287.89 66.524C287.89 64.4824 287.081 62.5246 285.638 61.081C284.195 59.6375 282.239 58.8265 280.198 58.8265H255.108C253.067 58.8265 251.111 58.0156 249.668 56.572C248.225 55.1284 247.416 53.1707 247.416 51.1291C247.416 49.0877 248.225 47.1299 249.668 45.6863C251.111 44.2428 253.067 43.4318 255.108 43.4318H269.647C271.689 43.4318 273.645 42.6209 275.088 41.1773C276.53 39.7337 277.34 37.776 277.34 35.7344C277.34 33.693 276.53 31.7351 275.088 30.2916C273.645 28.8481 271.689 28.0371 269.647 28.0371H234.039C232.453 28.0338 230.929 28.6524 229.792 29.7603C228.658 30.8682 228 32.3772 227.963 33.9641Z",
    fill: "url(#paint1_linear_22249_6021)",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M218.535 130.003H92.3027V127.252H218.535C218.9 127.252 219.25 127.397 219.508 127.655C219.766 127.913 219.911 128.263 219.911 128.627C219.911 128.992 219.766 129.342 219.508 129.6C219.25 129.858 218.9 130.003 218.535 130.003Z",
    fill: "#426572"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6559 130.003H78.938C78.5732 130.003 78.2234 129.858 77.9654 129.6C77.7075 129.342 77.5625 128.992 77.5625 128.627C77.5625 128.263 77.7075 127.913 77.9654 127.655C78.2234 127.397 78.5732 127.252 78.938 127.252H86.6559C87.0207 127.252 87.3705 127.397 87.6285 127.655C87.8865 127.913 88.0314 128.263 88.0314 128.627C88.0314 128.992 87.8865 129.342 87.6285 129.6C87.3705 129.858 87.0207 130.003 86.6559 130.003Z",
    fill: "#426572"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9303 130.003H71.4712C71.1064 130.003 70.7566 129.858 70.4986 129.6C70.2407 129.342 70.0957 128.992 70.0957 128.627C70.0957 128.263 70.2407 127.913 70.4986 127.655C70.7566 127.397 71.1064 127.252 71.4712 127.252H73.9303C74.2951 127.252 74.6449 127.397 74.9029 127.655C75.1609 127.913 75.3058 128.263 75.3058 128.627C75.3058 128.992 75.1609 129.342 74.9029 129.6C74.6449 129.858 74.2951 130.003 73.9303 130.003Z",
    fill: "#426572"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M262.799 130.003H224V127.252H262.799C263.163 127.252 263.514 127.397 263.772 127.655C264.03 127.913 264.174 128.263 264.174 128.627C264.174 128.992 264.03 129.342 263.772 129.6C263.514 129.858 263.163 130.003 262.799 130.003Z",
    fill: "#C3C3C3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4376 130.003H25.6367V127.252H64.4376C64.8024 127.252 65.1522 127.397 65.4102 127.655C65.6682 127.913 65.8131 128.263 65.8131 128.627C65.8131 128.992 65.6682 129.342 65.4102 129.6C65.1522 129.858 64.8024 130.003 64.4376 130.003Z",
    fill: "#C3C3C3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7317 22.6328H218.057C220.608 22.6328 223.523 23.196 225.327 24.9992C227.131 26.8026 227.676 29.698 227.677 32.2489V123.725H67.1113V32.2489C67.1124 29.698 67.5788 26.5254 69.3829 24.722C71.187 22.9188 74.181 22.6328 76.7317 22.6328Z",
    fill: "#C3C3C3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M220.22 29.5771H73.2422V114.669H220.22V29.5771Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M228.949 124.994H65.8438V28.1479C65.8461 26.3491 66.5616 24.6248 67.8334 23.3527C69.1053 22.0809 70.8298 21.3654 72.6283 21.3633H222.165C223.963 21.3654 225.688 22.0809 226.96 23.3527C228.231 24.6248 228.947 26.3491 228.949 28.1479V124.994ZM68.3832 122.455H226.41V28.1479C226.409 27.0223 225.961 25.9432 225.165 25.1473C224.369 24.3514 223.29 23.9038 222.165 23.9027H72.6283C71.5029 23.9038 70.4237 24.3514 69.6278 25.1473C68.8321 25.9432 68.3843 27.0223 68.3832 28.1479V122.455Z",
    fill: "#35363A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8613 120.695H252.234V121.37C252.234 123.559 251.364 125.658 249.817 127.206C248.268 128.754 246.169 129.624 243.981 129.624H55.1146C52.9258 129.624 50.8265 128.754 49.2787 127.206C47.7309 125.658 46.8613 123.559 46.8613 121.37V120.695Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M251.182 125.001C250.731 126.175 249.933 127.184 248.896 127.896C247.859 128.608 246.63 128.989 245.373 128.988H52.4415C51.1845 128.988 49.9569 128.607 48.9205 127.895C47.8842 127.183 47.0881 126.174 46.6367 125.001H251.182Z",
    fill: "#E3DFE9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M243.02 130.574H54.1558C51.6309 130.571 49.2104 129.567 47.4252 127.782C45.6397 125.996 44.6356 123.576 44.6328 121.051V119.106H252.545V121.051C252.543 123.576 251.538 125.997 249.751 127.783C247.965 129.568 245.544 130.572 243.02 130.574ZM47.1956 121.646C47.3445 123.389 48.1421 125.012 49.4305 126.195C50.7191 127.378 52.4044 128.035 54.1537 128.035H243.02C244.77 128.035 246.454 127.378 247.743 126.195C249.032 125.012 249.83 123.389 249.978 121.646H47.1956Z",
    fill: "#35363A"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M76.105 43.8194H220.751V31.1034L217.984 30.5947H91.3069H78.8685H74.2617V43.8194H76.105Z",
    fill: "#E5E5E5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M139.632 30.0801L116.029 118.95H104.143L127.746 30.0801H139.632Z",
    fill: "#F1EFF4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M169.928 30.0801L146.327 118.95H121.4L145.004 30.0801H169.928Z",
    fill: "#F1EFF4"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M223.048 112.112C223.048 113.943 221.564 115.427 219.733 115.427H75.0536C73.2226 115.427 71.7383 113.943 71.7383 112.112V31.6942C71.7383 29.8632 73.2226 28.3789 75.0536 28.3789H219.733C221.564 28.3789 223.048 29.8632 223.048 31.6942V112.112ZM74.2777 109.573C74.2777 111.404 75.762 112.888 77.593 112.888H217.193C219.024 112.888 220.508 111.404 220.508 109.573V34.2337C220.508 32.4027 219.024 30.9184 217.193 30.9184H77.593C75.762 30.9184 74.2777 32.4027 74.2777 34.2337V109.573Z",
    fill: "#35363A"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9037 44.8135H75.2837V109.813H83.9037V44.8135Z",
    fill: "#FAFAFA"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 77.0005,
    y: 49.7266,
    width: 4.53488,
    height: 4.53488,
    rx: 0.377907,
    fill: "#DCD7E4",
    fillOpacity: 0.6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 77.0005,
    y: 66.3545,
    width: 4.53488,
    height: 4.53488,
    rx: 0.377907,
    fill: "#DCD7E4",
    fillOpacity: 0.6
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 77.0005,
    y: 58.041,
    width: 4.53488,
    height: 4.53488,
    rx: 0.377907,
    fill: "#DCD7E4",
    fillOpacity: 0.6
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 77.0005,
    y: 74.6689,
    width: 4.53488,
    height: 4.53488,
    rx: 0.377907,
    fill: "#DCD7E4",
    fillOpacity: 0.6
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0107 40.0769C88.6094 40.3453 88.1371 40.4884 87.6545 40.4884C87.3338 40.4884 87.0166 40.4254 86.7203 40.3026C86.4243 40.1798 86.1547 39.9999 85.9281 39.7734C85.7015 39.5468 85.5216 39.2776 85.3988 38.9813C85.2759 38.685 85.2129 38.3676 85.2129 38.0469C85.2129 37.5639 85.3561 37.0922 85.6245 36.6905C85.893 36.2889 86.2739 35.9759 86.7203 35.7912C87.1662 35.6062 87.6573 35.5583 88.1307 35.6524C88.6042 35.7466 89.0394 35.9791 89.3808 36.3205C89.7223 36.6618 89.9548 37.0973 90.049 37.5707C90.1431 38.0445 90.0948 38.5347 89.9102 38.9809C89.7255 39.4272 89.4123 39.8085 89.0107 40.0769Z",
    fill: "#FFBD2E"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8944 40.0769C95.4931 40.3453 95.0212 40.4884 94.5382 40.4884C94.2175 40.4884 93.8999 40.4254 93.6036 40.3026C93.3072 40.1798 93.038 39.9999 92.8114 39.7734C92.5848 39.5468 92.4049 39.2776 92.2821 38.9813C92.1592 38.685 92.0962 38.3675 92.0962 38.0469C92.0962 37.5639 92.2394 37.0921 92.5078 36.6905C92.7763 36.2889 93.1576 35.9758 93.6036 35.7911C94.0495 35.6065 94.5406 35.5582 95.014 35.6524C95.4875 35.7465 95.9227 35.979 96.2641 36.3204C96.6056 36.6618 96.8381 37.0969 96.9323 37.5703C97.0264 38.0441 96.9781 38.5346 96.7935 38.9809C96.6088 39.4272 96.296 39.8085 95.8944 40.0769Z",
    fill: "#27C940"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1279 40.0769C81.7262 40.3453 81.2547 40.4884 80.7717 40.4884C80.1243 40.4884 79.5032 40.2312 79.0453 39.7734C78.5874 39.3155 78.3301 38.6945 78.3301 38.0469C78.3301 37.5639 78.4733 37.0921 78.7417 36.6905C79.0102 36.2889 79.3915 35.9762 79.8375 35.7911C80.2834 35.6065 80.7744 35.5582 81.2479 35.6524C81.7214 35.7465 82.1566 35.979 82.498 36.3204C82.8395 36.6618 83.072 37.0969 83.1662 37.5707C83.2603 38.0445 83.212 38.535 83.0273 38.9813C82.8427 39.4276 82.5295 39.8085 82.1279 40.0769Z",
    fill: "#FF6058"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M217.395 53.3311H86.7027C86.0654 53.3311 85.5488 53.8477 85.5488 54.4849V74.1772C85.5488 74.8145 86.0654 75.3311 86.7027 75.3311H217.395C218.032 75.3311 218.549 74.8145 218.549 74.1772V54.4849C218.549 53.8477 218.032 53.3311 217.395 53.3311Z",
    fill: "#F8F4FF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 90.5488,
    y: 56.3311,
    width: 19.2311,
    height: 3.84622,
    rx: 0.628123,
    fill: "#EAEAEA"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 90.5488,
    y: 56.3311,
    width: 19.2311,
    height: 3.84622,
    rx: 0.628123,
    fill: "#EAEAEA"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 90.5488,
    y: 63.3311,
    width: 126,
    height: 4,
    rx: 0.628123,
    fill: "#EAEAEA"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 90.5488,
    y: 69.3311,
    width: 126,
    height: 4,
    rx: 0.628123,
    fill: "#EAEAEA"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 156.549,
    y: 56.3311,
    width: 19.2311,
    height: 3.84622,
    rx: 0.628123,
    fill: "#EAEAEA"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 177.549,
    y: 56.3311,
    width: 19.2311,
    height: 3.84622,
    rx: 0.628123,
    fill: "#EAEAEA"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 197.549,
    y: 56.3311,
    width: 19.2311,
    height: 3.84622,
    rx: 0.628123,
    fill: "#EAEAEA"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M217.395 78.3311H86.7027C86.0654 78.3311 85.5488 78.8477 85.5488 79.4849V87.1772C85.5488 87.8145 86.0654 88.3311 86.7027 88.3311H217.395C218.032 88.3311 218.549 87.8145 218.549 87.1772V79.4849C218.549 78.8477 218.032 78.3311 217.395 78.3311Z",
    fill: "#F8F4FF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M217.395 89.3311H86.7027C86.0654 89.3311 85.5488 89.8477 85.5488 90.4849V98.1772C85.5488 98.8145 86.0654 99.3311 86.7027 99.3311H217.395C218.032 99.3311 218.549 98.8145 218.549 98.1772V90.4849C218.549 89.8477 218.032 89.3311 217.395 89.3311Z",
    fill: "#F8F4FF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M217.395 101.331H86.7027C86.0654 101.331 85.5488 101.848 85.5488 102.485V110.177C85.5488 110.814 86.0654 111.331 86.7027 111.331H217.395C218.032 111.331 218.549 110.814 218.549 110.177V102.485C218.549 101.848 218.032 101.331 217.395 101.331Z",
    fill: "#F8F4FF"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 86.5488,
    y: 46.3311,
    width: 19.2311,
    height: 3.84622,
    rx: 0.628123,
    fill: "#F2F2F5"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 158.549,
    y: 46.3311,
    width: 19.2311,
    height: 3.84622,
    rx: 0.628123,
    fill: "#F2F2F5"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 178.549,
    y: 46.3311,
    width: 19.2311,
    height: 3.84622,
    rx: 0.628123,
    fill: "#F2F2F5"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 198.549,
    y: 46.3311,
    width: 19.2311,
    height: 3.84622,
    rx: 0.628123,
    fill: "#F2F2F5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_22249_6021",
    x1: 68.8294,
    y1: 72.2417,
    x2: -10.1849,
    y2: 72.2417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3F6EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#C6EBFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_22249_6021",
    x1: 230.978,
    y1: 71.3566,
    x2: 294.521,
    y2: 70.2515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3F6EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#C6EBFD"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenNewTabImg);
export default __webpack_public_path__ + "static/media/open_new_tab_img.235235842960d64fddf44e8634f491af.svg";
export { ForwardRef as ReactComponent };